export default {
    // payments & place order
    getPaymentOptions: (outletId) =>
        `account/paymentoptions?outletId=${outletId}`,
    getPaymentAccessCode: (type) => `user/accesscode?ordertype=${type}`,
    getPaymentHash: "payment/paymenthash",
    placeOrder: "order/placeorder",
    paymentKitIframeSource: "https://www.zomato.com/zpaykit/init",
    updatePaymentStatus: (paymentGUID) =>
        `api/v3/payment/${paymentGUID}/updatePaymentStatus`,
    makePendingPayment: "payment/makependingpayment",
    getPaymentGUID: "api/payment/v2",


    // onboarding
    getDesignations: "consumer/onboarding/designations",

    getCities: "consumer/cities",
    validatePinCode: (cityId, pinCode) =>
        `api/buyeraccount/checkpincodeisserviceable?cityId=${cityId}&zipCode=${pinCode}`, // golang
    serviceablePinCode: (cityId, pinCode) => `/api/consumer/serviceability?cityId=${cityId}&zipCode=${pinCode}`,
    registerStepOne: "consumer/onboarding/saleslead",
    updateRegStepOne: (salesLeadId) =>
        `consumer/onboarding/saleslead${salesLeadId ? `/${salesLeadId}` : ""}`,
  registerStepTwo: "consumer/onboarding/documents",
  registerVerifyOtp: "api/usersignup/verifyotp", // golang
  registerAllSteps: "consumer/onboarding/complete",
  checkGst: (gst) => `api/buyeraccount/registration/checkgstin?gstin=${gst}`, // golang
  validatePhoneNumber: "consumer/onboarding/validateField",
  uploadOnboardDocument: "consumer/onboarding/verification",
  referralCode: (code) =>
    `api/buyeraccount/registration/checkreferralcode?referralCode=${code}`,
  getBonus: (referralCode = "none", cityId) =>
    `consumer/referral?type=${referralCode}&cityId=${cityId}`,
  getOtp: (phoneNumber) => `api/usersignup/otp?userPhoneNumber=${phoneNumber}`, // golang

  // user info
  v2_getUserData: esV2Flag=> `consumer/signInUser/v2?fetchThroughV2=${esV2Flag}`,
  getOutlets: "consumer/outlets",
  downloadExcelStatement: "consumer/statement/download/excel",
  getPDFStatementURL: "consumer/statement/download/pdf",
  emailStatement: "consumer/statement/email",
  v2_overDue: (source,categoryId, subCategoryId) => `consumer/outlet/status?source=${source}` + (categoryId ? `&categoryId=${categoryId}`: ``) + (subCategoryId ? `&subCategoryId=${subCategoryId}` : ``),

  getCredit: "api/creditmanagement/creditoutletdetail",


  // user management
  switchOutlet: "consumer/switchOutlet",
  verifyOtp: "consumer/editprofile/verifyotp",
  changeEmail: "consumer/user/emailupdate",
  changePhone: "consumer/user/phonenumber/update",
  changePassword: "consumer/password/resetPasswordFromWebProfile",
  changeName: "consumer/user/changename",
  resendEmail: "consumer/user/sendVerificationEmail",
  acceptTnC: `api/v2/buyeraccount/registration/signtnc`,

  // notifications
  getNotifications: (pageNumber) => `notifications?pageNumber=${pageNumber}`,
  markNotificationsRead: "notifications/markRead",
  getNotificationsStatus: "notifications/status",
  notifyOutOfStock: "consumer/product/notify",

  // referral
  sendReferalEmailInvite: "api/user/referralemailinvites",
  getReferral: (outletName, outletId) =>
    `consumer/referral-details?outletName=${outletName}&outletId=${outletId}`,

  // search and catalog
  getSearchSuggestions: (query, outletId, esV2Flag) =>
    `consumer/v2/autoSuggest?query=${query}&outletId=${outletId}&fetchThroughV2=${esV2Flag}`,
  getReqSearchSuggestions: (query, esV2Flag) =>
    `consumer/v2/autoSuggest?query=${query}&fetchThroughV2=${esV2Flag}&source=PRODUCT_REQUEST`,
  getProducts: ({
      query = "",
      outletId = "",
      pageNo,
      categoryIds = "",
      productIds = "",
      sortBy = "",
      sortType = "",
      onOffer = "",
      productNumbers = "",
      referenceType = "",
      referenceId = "",
      esV2Flag=false,
      searchDebugFlag= false,
    }) =>
    `consumer/v2/search?query=${query}&outletId=${outletId}&pageNo=${pageNo}&categoryIds=${categoryIds}&productIds=${productIds}&sortBy=${sortBy}&sortType=${sortType}&onOffer=${onOffer}&productNumbers=${productNumbers}&referenceType=${referenceType}&referenceId=${referenceId}&fetchThroughV2=${esV2Flag}&searchDebugFlag=${searchDebugFlag}`,
  getProductsWithQuery: (query, esV2Flag=false, debug=false) => `consumer/v2/search${query}&fetchThroughV2=${esV2Flag}&searchDebugFlag=${debug}`,
  v2_getCategoriesAndSubCategories: (
      accountId,
      visibleOnly,
      activeOnly,
      outletCityId,
      esV2Flag
    ) =>
    `consumer/categories?accountId=${accountId}&visibleOnly=${visibleOnly}&activeOnly=${activeOnly}&warehouseCityId=${outletCityId}&fetchThroughV2=${esV2Flag}`,
  v3_getCategoriesAndSubCategories: () => "/consumer/v2/categories",
  

  // cart
  getCart: (outletId, esV2Flag) => `consumer/v3/cart?outletId=${outletId}&fetchThroughV2=${esV2Flag}`,
  // checkoutCart: (outletId) => `consumer/checkout?outletId=${outletId}`,
  checkoutCart: (outletId, esV2Flag , isCheckoutPage) => `consumer/v3/checkout?outletId=${outletId}&fetchThroughV2=${esV2Flag}` + (isCheckoutPage ? `&isCheckoutPage=true` : ``),
  addUpdateDeleteCart: (esV2Flag, fromDetailPage) => `consumer/v3/cart?fetchThroughV2=${esV2Flag}&fromDetailPage=${fromDetailPage}`,

  // auth
  signIn: "api/registration/signin",
  forgotPasswordEnterPhone: (phoneNumber) =>
    `api/user/otpsms?isForgotPassword=true&userPhoneNumber=${phoneNumber}`,
  forgotPasswordVerifyOtp: "api/registration/forgotPasswordResetWeb",
  signOut: "consumer/signout",
  verifyEmail: "consumer/user/verifyEmail",

  // orders
  getOrder: (orderID, type) =>
    `consumer/order/history/details?${
      type === "number" ? "orderNumber" : "orderId"
    }=${orderID}`,
  reOrder: "consumer/orders/reorder",
  getOrders: (pageNumber, pageSize, filter) =>
    `consumer/order/history?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${filter}`,
  downloadFile: (filePath, fileName) =>
    `api/download?filepath=${filePath}&filename=${fileName}`,
  getCreditNote: (creditNoteNumber) =>
    `order/creditnote?creditNoteNumber=${creditNoteNumber}`,
  addOrderRating: "consumer/rating",

  // others
  testimonials: `consumer/testimonials`,
  v2_commercialBanner: (outletCityId) =>
    `consumer/banners/v2?cityId=${outletCityId}`,
  getConfig: "/consumer/config",
  validateLocation: "/consumer/outlet_location/validate",
  updateLocation: "/consumer/outlet_location",
  getHappyOtp: "/consumer/zonboarding/otp",
  onboardZomatoMerchant: "consumer/zonboarding/merchant",
  zomatoDocumentUplaod: "/consumer/zonboarding/document",
  zomatoVerifyPhone: (params = {}) =>
    `/consumer/zonboarding/checkUserPhone?phone=${params.phoneNumber}&sessionId=${params.sessionId}&merchantId=${params.merchantId}`,
  getMerchantDataFromZomato: `/consumer/zonboarding/merchant`,
  zomatoValidatePan: "/consumer/onboarding/validateField",
  refundToWallet: `/consumer/refund_source`,
  updateWhatsappNotificationStatus: `/consumer/user/updateWhatsappNotificationStatus`,
  trackOneClickSteps: "/consumer/zonboarding/step",
  getPopup: (source = "") => `/consumer/popup?source=${source}`,
  pastOrders: esV2Flag => `/consumer/orders/reorder/rail?fetchThroughV2=${esV2Flag}`,
  shareAppLink: "/consumer/applink",
  walletTransactions: (pageNumber, pageSize, filter) =>
    `/account/wallet/transactions?pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${filter}`,
  walletRecharge: "/accounts/walletrecharge",
  getRewards: "/consumer/loyalty/rewards",
  updatePayLater: "consumer/paylater/optin",
  track: "/consumer/tracking",
  openTrack: "/consumer/openTracking",
  getConsumerRail: (source, esV2Flag) => `/consumer/v2/rail?source=${source}&fetchThroughV2=${esV2Flag}`,
  autoSuggestHistory: `/consumer/autoSuggest/history`,
  clearHistory: `/consumer/autoSuggest/history`,
  setDeliverySlot: `/consumer/onboarding/deliveryslot`,
  setPinCode: `/consumer/onboarding/pincode`,
  semiServiceable: `/consumer/v2/semiServiceableSearch`,
  getFAQs: `/consumer/faqs`,
  getFAQAnswer: (id) => `consumer/faq?id=${id}`,
  accounts: `/consumer/accounts`,
  getAerobars: `/consumer/aerobars`,
  sideMenu: "consumer/v2/sidemenu",
  getAcquisitionRail: (client) => `consumer/reward/rail?client=${client}`,
  getDownloadDaApp: (appType, appVersion) => `/downloads/apk?appType=${appType}&appVersion=${appVersion}`, 
  getPaymentNudges: (source) => `consumer/nudges?source=${source}`,
  npsRating: "/consumer/npsrating",
  npsFeedbackRating: "/consumer/nps",
  requestProduct: "/consumer/request/product",
  getHomePage: "/consumer/home/rails",
  getProductDescMeta: (productId, source) => `/consumer/productDetail?source=${source}&productId=${productId}`,
  updateAccount: "/consumer/user/profile",
  updateOutlet: "/consumer/outletDetails",
  invoiceDetails: "/consumer/viewInvoice",
  getMilestoneDetails: "/consumer/milestoneDetails",
  autoOnboardingZomato: "/consumer/zonboarding/auto",
  getDeliveryTimeSlots: (cityId,outletId,source) => `/consumer/onboarding/deliveryTimeSlots?cityId=${cityId}` + (outletId ? `&outletId=${outletId}` : ``) + (source ? `&source=${source}` : ``),
  updateCheckout: "/consumer/checkout",
  zomatoGetStatus: "/consumer/zonboarding/getStatus",
  consumerPreferences: "/consumer/preferences",
  communications: (source,categoryId, subCategoryId) => `/consumer/communications?source=${source}` + (categoryId ? `&categoryId=${categoryId}`: ``) + (subCategoryId ? `&subCategoryId=${subCategoryId}` : ``),
  getMilestoneDetails: "/consumer/milestoneDetails",
  getCreditTransactions: (startDate,endDate,PageNo) => `account/creditTransactions?StartDate=${startDate}&EndDate=${endDate}&PageNo=${PageNo}`,
  getCreditTransactionDetails: (txnId) => `account/creditTransactions/details?transactionId=${txnId}`,
  getCreditPayments: `account/creditPayments/details`,
  makeCreditPayment: `account/creditPayment`
};